import { render, staticRenderFns } from "./wachtwoord-vergeten.html?vue&type=template&id=661b9030&scoped=true&"
import script from "./wachtwoord-vergeten.js?vue&type=script&lang=js&"
export * from "./wachtwoord-vergeten.js?vue&type=script&lang=js&"
import style0 from "./wachtwoord-vergeten.css?vue&type=style&index=0&id=661b9030&scoped=true&lang=css&"
import style1 from "@/css/appschoolware.css?vue&type=style&index=1&id=661b9030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b9030",
  null
  
)

export default component.exports